<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Brand Name"
                  v-model="brand.name"
                  type="text"
                  :rules="rules.brandNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Brand Code"
                  v-model="brand.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Brand Description"
                  v-model="brand.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="brand.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="brand.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="brand.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="brand.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="brand.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="brand.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="brand.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid || btnDisabled" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { brandService } from "../../services/brand-service";
import { Brand } from "../../models/model";
import { BrandFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
export default {
  name: "BrandDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Brand",
        disabled: false,
        to: "brands"
      },
      {
        text: "Brands Detail",
        disabled: true
      }
    ],
    updatedDate: "",
    createdDate: "",
    brand: new Brand(),
    oldBrand: new Brand(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new BrandFormRules(),
    btnDisabled: false,
  }),
  created() {
    if (this.user.role.roleName == "FINANCE_MANAGER") {
      this.btnDisabled = true;
    }
    const id = this.$route.params.id;
    if (id == "new") {
      // new brand
    } else {
      this.getBrandDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.brand.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let brandObj = {
          id: this.brand.id ? this.brand.id : "",
          name: this.brand.name,
          code: this.brand.code,
          description: this.brand.description,
          status: this.brand.status
        };
        brandService
          .saveBrand(brandObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getBrandDetail(id) {
      brandService
        .getBrandDetail(id)
        .then(res => {
          this.brand = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.brand.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.brand.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldBrand = Object.assign({}, res.data);
          this.statusFlag = this.brand.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.brand.id) {
        this.brand = new Brand();
        this.statusFlag = true;
      } else {
        this.brand = Object.assign({}, this.oldBrand);
        this.statusFlag = this.brand.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/brands");
    }
  }
};
</script>

